export default "__VITE_ASSET__CqMy1eYx__";